import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ClipboardCheck, BedDouble, ShieldCheck, Siren, Pill, Building2, ChevronDown } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'Admisión y Triage en Guardia',
  icon: ClipboardCheck,
  content: 'Triage en 5 minutos + EEM express + Plantilla de admisión completa + Flujograma internar/no internar + Nota de guardia lista para firmar',
  bg: 'bg-brand-mid'
}, {
  id: 2,
  title: 'Internación Sin Errores',
  icon: BedDouble,
  content: 'Nota de ingreso + Evolución diaria SOAP + Pase de guardia blindado + Indicaciones + Alta médica y voluntaria + Errores más frecuentes',
  bg: 'bg-teal-600'
}, {
  id: 3,
  title: 'El Escudo Legal del Hospital',
  icon: ShieldCheck,
  content: 'Ley 26.657 aplicada + Internación involuntaria paso a paso + Consentimiento informado + Habeas corpus + Responsabilidad médica + Qué hacer ante una denuncia',
  bg: 'bg-amber-600'
}, {
  id: 4,
  title: 'Crisis y Urgencias',
  icon: Siren,
  content: 'Riesgo suicida + Agitación psicomotriz + Psicosis aguda + Intento de suicidio + Fuga + Intoxicación dual + Violencia hacia el personal',
  bg: 'bg-red-600'
}, {
  id: 5,
  title: 'Farmacoterapia de Guardia',
  icon: Pill,
  content: 'Tabla maestra de fármacos en urgencias + Sedación por nivel + Interacciones críticas + Poblaciones especiales + SNM + Síndrome serotoninérgico + Equivalencias',
  bg: 'bg-indigo-600'
}, {
  id: 6,
  title: 'Supervivencia en el Sistema',
  icon: Building2,
  content: 'Pase de guardia blindado + Conflictos institucionales + Presentación de casos + Gestión del tiempo + Derechos del residente + Reputación profesional',
  bg: 'bg-brand-dark'
}];
export function TomosAccordion() {
  const [openId, setOpenId] = useState<number>(1);
  return <section className="py-8 md:py-20 bg-white" data-id="element-298">
      <div className="max-w-3xl mx-auto px-4" data-id="element-299">
        <div className="text-center mb-6 md:mb-10" data-id="element-300">
          <h2 className="text-[11px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1.5" data-id="element-301">
            CONTENIDO COMPLETO
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark mb-2 md:mb-4" data-id="element-302">
            LOS 6 TOMOS
          </h3>
          <p className="text-gray-600 text-xs md:text-base leading-snug" data-id="element-303">
            Tu hoja de ruta clínica y legal para cualquier situación en guardia
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4" data-id="element-304">
          {tomos.map(tomo => {
          const isOpen = openId === tomo.id;
          const Icon = tomo.icon;
          return <div key={tomo.id} className={`bg-white rounded-xl overflow-hidden border-2 transition-all duration-300 ${isOpen ? 'border-brand-mid shadow-lg' : 'border-gray-200 hover:border-brand-mid/40 hover:shadow-md'}`} data-id="element-305">
                {/* Representative image — 3:1 aspect ratio */}
                <button onClick={() => setOpenId(isOpen ? 0 : tomo.id)} className="w-full text-left focus:outline-none" aria-expanded={isOpen} data-id="element-306">
                  <div className={`relative aspect-[3/1] ${tomo.bg} overflow-hidden`} data-id="element-307">
                    {/* Subtle pattern overlay */}
                    <div className="absolute inset-0 opacity-10" style={{
                  backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
                  backgroundSize: '20px 20px'
                }} data-id="element-308"></div>
                    {/* Large ghost icon */}
                    <Icon className="absolute -right-8 -bottom-8 w-40 h-40 md:w-56 md:h-56 text-white/15" strokeWidth={1.5} data-id="element-309" />

                    {/* Foreground content */}
                    <div className="absolute inset-0 flex items-center justify-between px-4 md:px-6" data-id="element-310">
                      <div className="flex items-center gap-3 md:gap-5" data-id="element-311">
                        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/30" data-id="element-312">
                          <Icon className="w-5 h-5 md:w-7 md:h-7 text-white" data-id="element-313" />
                        </div>
                        <div data-id="element-314">
                          <span className="block text-white/80 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-0.5" data-id="element-315">
                            Tomo {tomo.id}
                          </span>
                          <h4 className="text-white font-heading text-base md:text-2xl leading-tight" data-id="element-316">
                            {tomo.title}
                          </h4>
                        </div>
                      </div>

                      <div className="bg-white/20 backdrop-blur-sm rounded-full p-1.5 md:p-2 border border-white/30 shrink-0" data-id="element-317">
                        <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-white transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-318" />
                      </div>
                    </div>
                  </div>
                </button>

                <AnimatePresence data-id="element-319">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-320">
                      <div className="px-4 py-4 md:px-6 md:py-5 bg-blue-50/30" data-id="element-321">
                        <p className="text-xs md:text-sm text-gray-700 leading-relaxed" data-id="element-322">
                          {tomo.content}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}